/* HK PDP bottom tabs (hk-pdp-bottom-tabs snippet): tab switching, description / specs "read more"
   collapse and the jump-to-specs links. One instance per [data-hk-btabs] root. */
(function () {
  'use strict';

  function init(root) {
    if (root.__hkBtabsInit) return;
    root.__hkBtabsInit = true;
    const uid = root.id;

    const collapse  = document.getElementById(uid + '-specs-collapse');
    const toggleBtn = document.getElementById(uid + '-specs-toggle');
    const toggleText = document.getElementById(uid + '-specs-toggle-text');
    // ── Description collapse ─────────────────
    const descCollapse  = document.getElementById(uid + '-desc-collapse');
    const descToggleBtn = document.getElementById(uid + '-desc-toggle');
    const descToggleText = document.getElementById(uid + '-desc-toggle-text');

    function checkDescToggleVisibility() {
      if (!descCollapse || !descToggleBtn) return;
      if (descCollapse.scrollHeight <= 420) {
        descToggleBtn.style.display = 'none';
      } else {
        descToggleBtn.style.display = 'flex';
      }
    }

    if (descToggleBtn) {
      descToggleBtn.addEventListener('click', function() {
        const open = descCollapse.classList.toggle('is-open');
        descToggleBtn.classList.toggle('is-open', open);
        descToggleText.textContent = descToggleBtn.getAttribute(open ? 'data-label-open' : 'data-label-closed');

        // If closing, scroll back up to the top of the card
        if (!open) {
          const offset = 80; // adjust this value if needed to clear your header
  const top = root.getBoundingClientRect().top + window.pageYOffset - offset;
  window.scrollTo({ top: top, behavior: 'smooth' });
        }
      });
    }

    // Check on load (desc tab is active by default)
    setTimeout(checkDescToggleVisibility, 100);

    // ── Toggle button logic ──────────────────
    function checkToggleVisibility() {
      if (!collapse || !toggleBtn) return;
      if (collapse.scrollHeight <= 420) {
        toggleBtn.style.display = 'none';
      } else {
        toggleBtn.style.display = 'flex';
      }
    }

    if (toggleBtn) {
      toggleBtn.addEventListener('click', function() {
        const open = collapse.classList.toggle('is-open');
        toggleBtn.classList.toggle('is-open', open);
        toggleText.textContent = toggleBtn.getAttribute(open ? 'data-label-open' : 'data-label-closed');

        // If closing, scroll back up to the top of the card
        if (!open) {
          const offset = 80; // adjust this value if needed to clear your header
  const top = root.getBoundingClientRect().top + window.pageYOffset - offset;
  window.scrollTo({ top: top, behavior: 'smooth' });
        }
      });
    }

    // ── Tab switching ────────────────────────
    // ARIA tabs pattern: roving tabindex, Left/Right/Home/End (A11Y-010)
    const tabBtns = Array.prototype.slice.call(root.querySelectorAll('.hk-btabs__btn'));

    function activate(btn, moveFocus) {
      const tab = btn.getAttribute('data-tab');

      tabBtns.forEach(function(b) {
        const active = (b === btn);
        b.classList.toggle('is-active', active);
        b.setAttribute('aria-selected', active ? 'true' : 'false');
        b.tabIndex = active ? 0 : -1;
      });

      root.querySelectorAll('.hk-btabs__panel').forEach(function(p) {
        p.classList.toggle('is-active', p.getAttribute('data-panel') === tab);
      });
      if (moveFocus) btn.focus();

      // Measure after spec tab becomes visible
      if (tab === 'spec') { setTimeout(checkToggleVisibility, 50); }
      if (tab === 'desc') { setTimeout(checkDescToggleVisibility, 50); }
    }

    root.addEventListener('click', function(e) {
      const btn = e.target.closest('.hk-btabs__btn');
      if (btn) activate(btn, false);
    });

    root.addEventListener('keydown', function(e) {
      const i = tabBtns.indexOf(e.target);
      if (i < 0) return;
      let n = null;
      if (e.key === 'ArrowRight') n = (i + 1) % tabBtns.length;
      else if (e.key === 'ArrowLeft') n = (i - 1 + tabBtns.length) % tabBtns.length;
      else if (e.key === 'Home') n = 0;
      else if (e.key === 'End') n = tabBtns.length - 1;
      if (n === null) return;
      e.preventDefault();
      activate(tabBtns[n], true);
    });

    // Check on load in case spec tab is active by default
    setTimeout(checkToggleVisibility, 100);
  // ── Spec chip → scroll & switch to Indicații Tehnice ────
    document.querySelectorAll('.hk-spec-chip').forEach(function(chip) {
      chip.addEventListener('click', function() {
        // Switch to the spec tab
        const specBtn = root.querySelector('.hk-btabs__btn[data-tab="spec"]');
        if (specBtn) activate(specBtn, false);

        // Scroll down to the tabs
        const offset = 80; // adjust this value if needed to clear your header
  const top = root.getBoundingClientRect().top + window.pageYOffset - offset;
  window.scrollTo({ top: top, behavior: 'smooth' });
      });
    });
  }

  function initAll(scope) { (scope || document).querySelectorAll('[data-hk-btabs]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); }, { once: true });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
